import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SCRIPT_ID = 'chatingo-widget-script';

export const removeChatingoArtifacts = () => {
  try {
    console.log('🧹 Removing Chatingo artifacts...');
    // Remove the script tag(s)
    document.querySelectorAll('script[src*="chatingo.datagrid.co.in"]').forEach(el => el.remove());
    const existingScript = document.getElementById(SCRIPT_ID);
    if (existingScript) existingScript.remove();

    // Remove iframes created by the widget
    document.querySelectorAll('iframe[src*="chatingo.datagrid.co.in"], iframe[src*="datagrid.co.in"]').forEach(el => el.remove());

    // Remove any containers likely created by the widget
    document.querySelectorAll('[id*="chatingo"], [class*="chatingo"], [data-company="glamify1755769505170"], #chat-widget-container, .chat-widget-bottom-right').forEach(el => el.remove());
  } catch (e) {
    console.error('❌ Error removing Chatingo artifacts:', e);
  }
};

const hideChatWidget = () => {
  try {
    const chatElements = document.querySelectorAll('[id*="chatingo"], [class*="chatingo"], [data-company="glamify1755769505170"], #chat-widget-container, .chat-widget-bottom-right');
    if (chatElements.length > 0) {
      console.log('🙈 Hiding chat widget...');
      chatElements.forEach(el => {
        el.style.setProperty('display', 'none', 'important');
      });
    }
  } catch (e) {
    // no-op
  }
};

const showChatWidget = () => {
  try {
    const chatElements = document.querySelectorAll('[id*="chatingo"], [class*="chatingo"], [data-company="glamify1755769505170"], #chat-widget-container, .chat-widget-bottom-right');
    if (chatElements.length > 0) {
      console.log('👁️ Showing chat widget...');
      chatElements.forEach(el => {
        el.style.setProperty('display', '', 'important');
      });
    }
  } catch (e) {
    // no-op
  }
};

const ChatWidgetLoader = () => {
  const location = useLocation();

  // Routes where chat widget should be hidden
  const hiddenRoutes = ['/login', '/forgot-password', '/register', '/whatsapp-signup', '/sms-signup', '/verify-otp', '/verify-email'];

  // Check if current route should hide chat widget
  const shouldHideChatWidget = hiddenRoutes.includes(location.pathname);

  useEffect(() => {
    console.log(`📍 ChatWidgetLoader: Path changed to ${location.pathname}, shouldHide: ${shouldHideChatWidget}`);

    if (shouldHideChatWidget) {
      // Instead of removing, we hide it first to keep it responsive
      // But if it's a "clean" logout, we might want to remove. 
      // For now, let's just hide to see if it fixes the SPA issue.
      hideChatWidget();
      return;
    }

    // If we shouldn't hide, but the script is missing, load it
    if (!document.getElementById(SCRIPT_ID)) {
      console.log('🚀 Injecting Chatingo script...');
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = 'https://chatingo.datagrid.co.in/widget/glamify1755769505170.js';
      script.async = true;
      script.dataset.theme = '#0292f2';
      script.dataset.company = 'glamify1755769505170';
      
      script.onload = () => {
        console.log('✅ Chatingo script loaded successfully');
      };
      
      document.body.appendChild(script);
    } else {
      // If script exists, just make sure it's visible
      showChatWidget();
    }

    // Set up observer to hide chat widget when modals are open
    const observer = new MutationObserver((mutations) => {
      const hasModal = document.querySelector('.MuiDialog-root');
      if (hasModal) {
        hideChatWidget();
      } else if (!shouldHideChatWidget) {
        showChatWidget();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => {
      observer.disconnect();
    };
  }, [shouldHideChatWidget, location.pathname]);

  return null;
};

export default ChatWidgetLoader;